import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { territorio } from '../../shared/object/territorio.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { SecurityService } from '../../shared/services/security.service';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-territorio',
  templateUrl: './territorio.component.html',
  styleUrls: ['./territorio.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class TerritorioComponent implements OnInit {
  private client: GraphQLClient = null;
  territorioList: territorio[];
  selectedTer: territorio;
  territorio: territorio;

  public rut_empresa;
  public sucursal_codigo;

  public activos;
  public inactivos;
  public todos;
  public busquedaEstado;

  public formAgregarTerritorio: FormGroup;
  public formEditarTerritorio: FormGroup;

  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('centralLargex', { static: true }) editarModal: ModalDirective;
  public codgo_modulo: number = 6;
  public rut_usuario = Number(this.accesolocalstorage.getRutUsuario());

  constructor(client: GraphQLClient, private accesolocalstorage: SecurityService, private toastService: ToastService, public validadores: ValidadoresService) {
    this.client = client;
    this.formAgregarTerritorio = this.construyeFormAgrega();
    this.formEditarTerritorio = this.construyeFormEdita();
    this.busquedaEstado = 1;
  }

  ngOnInit() {
    this.selectedTer = {
      codigo_distribuidor: null,
      codigo: null,
      nombre: '',
      descripcion: '',
      empresa_rut: null,
      estado: null,
      sucursal_codigo: null,
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();

    this.obtenerDatosTerritorio(Number(this.rut_empresa), Number(this.sucursal_codigo));
  }
  /*************************************************************/
  /*************declaracion de formulario***********************/
  /*************************************************************/
  construyeFormAgrega() {
    return new FormGroup({
      nombre: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      descripcion: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]),
      estado: new FormControl(true),
      codigo_distribuidor: new FormControl('', [Validators.required, Validators.pattern(/^\d+$/)]),
    });
  }

  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl({ value: '', disabled: true }),
      codigo_distribuidor: new FormControl('', [Validators.required]),
      empresa_rut: new FormControl(''),
      sucursal_codigo: new FormControl(''),
      nombre: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      descripcion: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]),
      estado: new FormControl(true),
    });
  }

  filtraxEstado() {
    this.obtenerDatosTerritorio(Number(this.rut_empresa), Number(this.sucursal_codigo));
  }

  get frmAgregaNombre() {
    return this.formAgregarTerritorio.get('nombre');
  }
  get frmAgregaCodigo() {
    return this.formAgregarTerritorio.get('codigo_distribuidor');
  }
  get frmAgregaDescripcion() {
    return this.formAgregarTerritorio.get('descripcion');
  }
  get frmAgregaEstado() {
    return this.formAgregarTerritorio.get('estado');
  }

  get frmEditarCodigo() {
    return this.formEditarTerritorio.get('codigo');
  }

  get frmEditarCodigoDistribuidor() {
    return this.formEditarTerritorio.get('codigo_distribuidor');
  }
  get frmEditarRut_Empresa() {
    return this.formEditarTerritorio.get('empresa_rut');
  }
  get frmEditarSucursal_Codigo() {
    return this.formEditarTerritorio.get('sucursal_codigo');
  }
  get frmEditarNombre() {
    return this.formEditarTerritorio.get('nombre');
  }
  get frmEditarDescripcion() {
    return this.formEditarTerritorio.get('descripcion');
  }
  get frmEditarEstado() {
    return this.formEditarTerritorio.get('estado');
  }

  /*************************************************************/
  /*************************************************************/

  showForEdit(ter: territorio) {
    this.selectedTer = Object.assign({}, ter);
    this.formEditarTerritorio.reset();
    this.frmEditarCodigoDistribuidor.setValue(this.selectedTer.codigo_distribuidor);
    this.frmEditarCodigo.setValue(this.selectedTer.codigo);
    this.frmEditarNombre.setValue(this.selectedTer.nombre);
    this.frmEditarDescripcion.setValue(this.selectedTer.descripcion);
    this.frmEditarNombre.setValue(this.selectedTer.nombre);
    this.frmEditarEstado.setValue(this.selectedTer.estado);
    this.frmEditarRut_Empresa.setValue(this.selectedTer.empresa_rut);
    this.frmEditarSucursal_Codigo.setValue(this.selectedTer.sucursal_codigo);
  }

  obtenerDatosTerritorio(rut_empresa: number, sucursal_codigo: number) {
    let self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $tipobusqueda: Int) {
            territorio {
              obtenerSegunFiltro(filtro: { exacto: { empresa_rut: $rut_empresa, sucursal_codigo: $sucursal_codigo, tipobusqueda: $tipobusqueda } }) {
                respuesta {
                  registros {
                    codigo_distribuidor
                    codigo
                    nombre
                    descripcion
                    empresa_rut
                    sucursal_codigo
                    estado
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rut_empresa: rut_empresa,
          sucursal_codigo: sucursal_codigo,
          tipobusqueda: this.busquedaEstado,
        },
      },
      function (respuesta) {
        self.territorioList = respuesta.data.territorio.obtenerSegunFiltro.respuesta.registros;
      }
    );
  }

  cambiaEstado(territorio_seleccionado: territorio) {
    let territorioSeleccionado: territorio;
    territorioSeleccionado = territorio_seleccionado;

    if (territorioSeleccionado.estado) {
      territorioSeleccionado.estado = false;
    } else {
      territorioSeleccionado.estado = true;
    }
    this.refrescar(territorioSeleccionado);
  }

  muestraModalAgrega() {
    this.selectedTer = {
      empresa_rut: null,
      sucursal_codigo: null,
      codigo_distribuidor: null,
      codigo: null,
      nombre: '',
      descripcion: '',
      estado: true,
    };
    this.formAgregarTerritorio.reset();
  }

  insertar() {
    this.territorio = {
      codigo_distribuidor: Number(this.frmAgregaCodigo.value),
      codigo: Number(this.frmAgregaCodigo.value),
      empresa_rut: Number(this.rut_empresa),
      sucursal_codigo: Number(this.sucursal_codigo),
      descripcion: this.frmAgregaDescripcion.value,
      nombre: this.frmAgregaNombre.value,
      estado: this.frmAgregaEstado.value,
    };

    //SI CODIGO EXISTE NO PUEDE GUARDARSE EL TERRITORIO

    this.postTerritorio(this.territorio);
  }

  postTerritorio(nuevoTerritorio: territorio) {
    let self = this;
    var bodyx = nuevoTerritorio;
    //var self = this;
    this.client.mutate(
      {
        mutation: gql`
          mutation ($entidad: territorioInputType) {
            territorio {
              guardarTerritorio(entidad: $entidad) {
                respuesta {
                  codigo
                  codigo_distribuidor
                  nombre
                  descripcion
                }
                mensajes {
                  tipo
                  texto
                  contexto
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.territorio.guardarTerritorio.respuesta == null) {
          if (respuesta.data.territorio.guardarTerritorio.mensajes.length > 0) {
            self.toastService.warning(respuesta.data.territorio.guardarTerritorio.mensajes[0].texto);
          }
        }
        setTimeout(() => self.obtenerDatosTerritorio(Number(self.rut_empresa), Number(self.sucursal_codigo)), 1000);
      }
    );
  }

  actualizar() {
    this.territorio = {
      codigo_distribuidor: this.frmEditarCodigoDistribuidor.value,
      codigo: this.frmEditarCodigo.value,
      descripcion: this.frmEditarDescripcion.value,
      nombre: this.frmEditarNombre.value,
      estado: this.frmEditarEstado.value,
      empresa_rut: this.frmEditarRut_Empresa.value,
      sucursal_codigo: this.frmEditarSucursal_Codigo.value,
    };

    this.refrescar(this.territorio);
  }
  refrescar(territorio_modificado: territorio) {
    let self = this;
    delete territorio_modificado['__typename'];
    let bodyx = territorio_modificado;

    this.client.mutate(
      {
        mutation: gql`
          mutation ($entidad: territorioInputType) {
            territorio {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.territorio.guardar.respuesta == null) {
          if (respuesta.data.territorio.guardar.mensajes.length > 0) {
            alert(respuesta.data.territorio.guardar.mensajes[0].texto);
          }
        }
        setTimeout(() => self.obtenerDatosTerritorio(Number(self.rut_empresa), Number(self.sucursal_codigo)), 1000);
      }
    );
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3;
    this.client.query(
      {
        query: gql`
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: {
          rut_usu: self.rut_usuario,
          codgo_modulo: self.codgo_modulo,
          cod_operacion: codigo_operacion,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
        if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
          self.agregarModal.show();
        } else {
          alert(notificacion.mensajes[0].texto);
        }
      }
    );
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2;
    this.client.query(
      {
        query: gql`
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: {
          rut_usu: self.rut_usuario,
          codgo_modulo: self.codgo_modulo,
          cod_operacion: codigo_operacion,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
        if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
          self.editarModal.show();
        } else {
          alert(notificacion.mensajes[0].texto);
        }
      }
    );
  }
  permitirCambioEstado(territorio_seleccionado: territorio) {
    const self = this;
    let codigo_operacion = 4;
    this.client.query(
      {
        query: gql`
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: {
          rut_usu: self.rut_usuario,
          codgo_modulo: self.codgo_modulo,
          cod_operacion: codigo_operacion,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
        if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
          self.cambiaEstado(territorio_seleccionado);
        } else {
          alert(notificacion.mensajes[0].texto);
        }
      }
    );
  }
}
